var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = '${{amount}}';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};





function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) {
    elementToFocus.focus();
    setTimeout(function() {
      elementToFocus.blur();
    }, 100);
  }
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const allTabs = document.querySelectorAll('.menu-drawer__navigation ul > details');
    const noGenderLocalization = document.querySelectorAll('.localization-test')[0];

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (summaryElement.parentNode.classList.contains('menu-tab')) {
      for (let i = 0; i < allTabs.length; i++) {
        allTabs[i].removeAttribute('open');
      }
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      let animationTime = 0;

      setTimeout(() => {
        // if not gender selected remove class
        if(document.body.classList.contains('gender-generic')) {
          document.body.classList.remove('gender-generic');
          noGenderLocalization.classList.remove('localization-test');
        }

        document.body.setAttribute('menu-child-open', true);
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, animationTime);
    }
  }

  openMenuDrawer(summaryElement) {
    document.body.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
     // details.removeAttribute('open');
    // details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 300) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class Megamenu extends HTMLElement {
  constructor() {
    super();
    this.megamenu = document.querySelector('mega-menu');
    this.megamenuLevel2Voices = this.querySelectorAll('.level3');
    this.isiPadPro = window.matchMedia(
      'only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) and (hover: none)'
  ).matches;

    if (!this.isiPadPro ) {
      this.init();
    }
  }

  init() {
    this.hoverSubChildMegaMenuVoices();
  }

  megamenuVoiceOpen(targetItem) {
    targetItem.classList.add('visible');
    document.body.classList.add('menu-open')
    document.querySelector('#MainContent').classList.add('blur')
  }

  // Function to close the mega menu and reset styles
  megamenuVoiceClose(targetItem) {
    targetItem.classList.remove('visible');
    document.body.classList.remove('menu-open')
    document.querySelector('#MainContent').classList.remove('blur')
  }

  hoverSubChildMegaMenuVoices() {
    new SV.HoverIntent(this.megamenuLevel2Voices, {
      onEnter: targetItem => this.megamenuVoiceOpen(targetItem),
      onExit: targetItem => this.megamenuVoiceClose(targetItem),
      exitDelay: 0,
      interval: 100,
      sensitivity: 7
    });
  }

}

customElements.define('mega-menu', Megamenu);


class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  connectedCallback() {
    const walletBtns = this.querySelectorAll('[data-wallet]');
    if (!walletBtns) return
    Array.from(walletBtns).forEach(walletBtn => {
      walletBtn.onclick = () => {
        publish(PUB_SUB_EVENTS.openLoyalty)
      }
    })

  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    }); 

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add('menu-open');
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
    document.body.classList.remove('menu-open');
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      //if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
       // if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
       // if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;

    Antonioli.sliderIndex = 0;

    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();

  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('preorder-product');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }
  
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    const inputLanguage = this.querySelector('input[name="language_code"]');
    const inputCountry = this.querySelector('input[name="country_code"]');
    const form = this.querySelector('form');
    this.openLang = document.querySelector('.open-language');
    this.openCountries = document.querySelector('.open-countries');
    this.openSpecificTab = false;
    this.elements = { inputLanguage, inputCountry, form };
    form.addEventListener('submit', (event) => {
      AntonioliCookieFunctions.createCookie('forceLocalization', true);
      AntonioliCookieFunctions.deleteCookie('currentMarket');
    })
    this.init();
    this.initSidebarClickListeners();

  }


  initSidebarClickListeners() {
    const openSidebarItems = document.querySelectorAll('.open-sidebar li');
    openSidebarItems.forEach(item => {
        item.addEventListener('click', () => {
            const dataOpen = item.getAttribute('sidebar-open');
            if (dataOpen === 'shipping-language') {
                this.openLang.click();
            } else if (dataOpen === 'shipping-countries') {
                this.openCountries.click();
            }
        });
    });
  }

  init() {
    const toggleVisibility = (parent, selectorToShow, selectorToHide) => {
      this.openLang.classList.remove('opened');
      this.openCountries.classList.remove('opened');
      parent.classList.add('opened');
      document.querySelector(selectorToShow).classList.remove('tw-hidden');
      document.querySelector(selectorToHide).classList.add('tw-hidden');
    };
  
    const handleClick = (parent,showSelector, hideSelector) => {
      return () => {
        toggleVisibility(parent, showSelector, hideSelector);
      };
    };  

    this.openLang.addEventListener('click', handleClick(this.openLang, '#LanguageList', '#CountryList'));
    this.openCountries.addEventListener('click', handleClick(this.openCountries,'#CountryList', '#LanguageList'));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();
    const { target } = event;
    const type = target.getAttribute('type');
    const value = target.dataset.value;

    // rimuovo la classe tw-h3-med da tutti gli elementi non cliccati
    this.querySelectorAll('a').forEach(item => {
        if (item !== target) {
            item.classList.remove('tw-h3-med');
            item.classList.add('tw-h3-reg');
        }
    });

    target.classList.add('tw-h3-med');
    target.classList.remove('tw-h3-reg');

    if (type === 'language') {
      this.elements.inputLanguage.value = value;
    } else if (type === 'country') {
      this.elements.inputCountry.value = value;
    }
    
    let cookieExists = AntonioliCookieFunctions.checkCookieExists("gender_redirect");
    if (cookieExists) {
      let gender = AntonioliCookieFunctions.splitCookieValue(AntonioliCookieFunctions.getCookieValue("gender_redirect"), "gpref");
      let urlLanguage = AntonioliCookieFunctions.splitCookieValue(AntonioliCookieFunctions.getCookieValue("gender_redirect"), "lang");
      let urlCountry = AntonioliCookieFunctions.splitCookieValue(AntonioliCookieFunctions.getCookieValue("gender_redirect"), "country");
      if (type === 'language') {
        urlLanguage = value;
      } else if (type === 'country') {
        urlCountry = value;
      }

      /*AT-846: ANTONIOLI_bug redirect: questo codice qua sotto serve per controllare se i prodotti venuti fuori
      da una ricerca matchano col giusto gender oppure no, se c'è match prende di default il valore del cookie, altrimenti
      lo aggiorna con quello corretto  */
      let cookieValueToPass = "lang=" + urlLanguage + "&" + "country=" + urlCountry + "&" + "gpref=" + gender;

      if (Antonioli.settings.template == 'collection' &&  window.location.href.includes("designer-")) {
        let genderFromUrl = window.location.href.includes("designer-") ? window.location.href.split("designer-")[1].split('/')[1] : null;
        if(genderFromUrl != gender) {
           cookieValueToPass = "lang=" + urlLanguage + "&" + "country=" + urlCountry + "&" + "gpref=" + genderFromUrl;
           localStorage.setItem("gender_redirect", genderFromUrl);
           localStorage.setItem("active_gender", `/collections/${genderFromUrl}`);
        }
    }

      AntonioliCookieFunctions.changeCookieValue("gender_redirect", cookieValueToPass)
    }
  }
}

customElements.define('localization-form', LocalizationForm);

class InputFilter extends HTMLElement {
  constructor() {
    super();
    this.filterInput = this.querySelector('input');
    this.listSelector = this.getAttribute('list-selector');
    this.itemSelector = this.getAttribute('item-selector');

    if (!this.filterInput || !this.listSelector || !this.itemSelector) {
      console.error('Missing required attributes: filter input, list selector, or item selector');
      return;
    }

    this.init();
  }

  init() {
    const itemList = [...document.querySelector(this.listSelector).querySelectorAll(this.itemSelector)];

    this.filterInput.addEventListener('input', () => {
      const filterValue = this.filterInput.value.trim().toLowerCase();

      itemList.forEach(item => {
        const itemText = item.textContent.trim().toLowerCase();
        const isVisible = itemText.includes(filterValue);
        item.style.display = isVisible ? 'block' : 'none';
      });
    });
  }
}

customElements.define('input-filter', InputFilter);


document.addEventListener('DOMContentLoaded', function(){
  var live_url = window.location.href;
  var result = live_url.includes('form_type=customer');
  var input_val = document.querySelector('input[type="email"]').value.length;


  if(result && input_val != 0){
    const add_ele_inline = document.createElement("small");
    const customElementErrorField = document.querySelector('error-block #error-message');
    add_ele_inline.innerText = document.querySelector('input[name="contact[email]"]').getAttribute('data-message');

    customElementErrorField.append(add_ele_inline);

    const add_ele_banner = document.createElement("h3");
    add_ele_banner.innerText = document.querySelector('input[name="contact[email]"]').getAttribute('data-message');
    add_ele_banner.classList.add('newsletter_already_subscribe-banner','newsletter-form__message','form__message');
    document.querySelector('.newsletter-footer_cta').parentElement.append(add_ele_banner);
  }

  if(window.screen.width > 759){
    document.getElementById('MainContent').classList.add('tw-relative');
  }
})

document.addEventListener('DOMContentLoaded', function(){
  let stickyContainer = document.querySelectorAll('.banner-sticky-container');
  stickyContainer.forEach(container =>{
    let stickyBlocks = Array.from(container.children);
    stickyBlocks.forEach(block => {
      let blockClasses = Array.from(block.classList); 
      blockClasses.forEach(classEl =>{
        if (classEl == "sticky-cta" && window.screen.width < 1024) {
          const containerRect = container.getBoundingClientRect();
          let headerOffset = document.querySelector('sticky-header').clientHeight;
          let halfContainerHeight = containerRect.height  / 2;
          let offset = halfContainerHeight + containerRect.top - headerOffset;

          document.addEventListener('scroll', ()=>{
            if (window.scrollY > offset) {
              block.style.position = 'sticky';
              block.style.bottom      = '80%';
              block.style.top      = 'unset';
              block.style.padding  = '0 1.6rem'
              container.style.margin = '0 0 -7rem 0';
            } else {
              block.style.position = 'absolute';
              block.style.top      = '50%';
              block.style.padding  = '1rem 1.6rem 2.8rem 1.6rem'
              container.style.margin = 'unset';
            }
          })
        }
      })
    })  
  })
})



function UtmUrlSearch() {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = new URLSearchParams();

  for (const [key, value] of urlParams.entries()) {
    if (key.startsWith('utm_')) {
      utmParams.set(key, value);
    }
  }

  if (utmParams) {
    return utmParams.toString();
  } else {
    return "";
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  let links = document.querySelectorAll("a[href]");
  links.forEach(function (element) {
    let hrefValueSplitted = element.getAttribute('href').split(/\W+/);

    element.addEventListener("click", function (event) {
      // Check the cookie gender_redirect
      const cookieExists = AntonioliCookieFunctions.checkCookieExists("gender_redirect");

      // Data relating to the selected language and country, 
      // saved them and then pass them to the cookie for a better redirect
      let urlLanguage = "";
      let urlCountry = "";
      let themeRootUrlWithoutSlash = window.routes.rootUrlWithoutSlash;

      if (themeRootUrlWithoutSlash != '') {
        themeRootUrlWithoutSlash = themeRootUrlWithoutSlash.split(/\W+/);
        urlLanguage = themeRootUrlWithoutSlash[1];
        urlCountry = themeRootUrlWithoutSlash[2];
      }

      // Funzione per gestire il redirect in base al genere
      function handleGenderRedirect(gender, cookieExists) {
        let cookieValueToPass = "lang=" + urlLanguage + "&" + "country=" + urlCountry + "&" + "gpref=" + gender;
        localStorage.setItem("active_gender", gender);

        if (!cookieExists) {
          AntonioliCookieFunctions.createCookie("gender_redirect", cookieValueToPass, 10);
          return
        }

        const myCookieValue = AntonioliCookieFunctions.getCookieValue("gender_redirect");
        const currentGender = AntonioliCookieFunctions.splitCookieValue(myCookieValue, "gpref");

        // Verifica se il valore del cookie è diverso da quello attuale
        if (currentGender != gender) {
          AntonioliCookieFunctions.changeCookieValue("gender_redirect", cookieValueToPass);
        }

      }

      if(Antonioli.settings.template === 'product' && event.srcElement.dataset.gender) {
        handleGenderRedirect(event.srcElement.dataset.gender, cookieExists);
        localStorage.setItem("active_gender", event.srcElement.dataset.gender);
      }


      // Controlla se l'href contiene "man" o "woman" e chiama la funzione corrispondente
      if (hrefValueSplitted.includes("man")) {
        handleGenderRedirect("man", cookieExists);
      } else if (hrefValueSplitted.includes("woman")) {
        handleGenderRedirect("woman",cookieExists);
      }


      const utmString = UtmUrlSearch();
      if (utmString) {
        let currentHref = new URL(element.href, window.location.origin);
        currentHref.search += (currentHref.search ? '&' : '?') + utmString;
        element.href = currentHref.toString();
      }
    });
  });
  // Gestione del redirect basato sul cookie esistente
  if (!window.location.href.includes('designer-')) { return }

  const myCookieValue = AntonioliCookieFunctions.getCookieValue("gender_redirect");
  const url = window.location.href.toLowerCase();

  const includesWoman = url.includes('/woman')
  const includesMan = url.includes('/man')
  const includesUnisex = url.includes('/unisex')

  const hasSubFolder = includesWoman || includesMan || includesUnisex

  if (myCookieValue && !hasSubFolder) {
      window.location.pathname += myCookieValue.includes('woman') ? "/woman" : "/man";
      return
  }

  if (includesUnisex) {
    AntonioliCookieFunctions.changeCookieValue("gender_redirect", '');
    return;
  }
});

document.addEventListener("DOMContentLoaded", (event) => {
  let logo = document.querySelector('.header__heading-link');

  if(!AntonioliCookieFunctions.checkCookieExists("currentMarket")){
    AntonioliCookieFunctions.createCookie("currentMarket", Shopify.routes.root, 10);
  }

  if(AntonioliCookieFunctions.checkCookieExists("gender_redirect")){
    let myCookieValue = AntonioliCookieFunctions.getCookieValue("gender_redirect");
    let gender = AntonioliCookieFunctions.splitCookieValue(myCookieValue, "gpref");
    if (logo.getAttribute('href').endsWith('/')){
      gender == 'woman' ? logo.setAttribute('href', logo.getAttribute('href') + 'collections/woman') : logo.setAttribute('href', logo.getAttribute('href') + 'collections/man');
      } else {
      gender == 'woman' ? logo.setAttribute('href', logo.getAttribute('href') + '/collections/woman') : logo.setAttribute('href', logo.getAttribute('href') + '/collections/man');
    }
  }
})

document.addEventListener("DOMContentLoaded", (event) => {
  const url = window.location.href.toLowerCase();
  let gender = AntonioliCookieFunctions.splitCookieValue(AntonioliCookieFunctions.getCookieValue("gender_redirect"), "gpref");
  if (url.includes('/unisex') && gender != '') {
    let currentVendorHref = document.querySelector('a.product-vendor').href;
    let currentVendorHrefArray = currentVendorHref.split('/unisex');
    document.querySelector('a.product-vendor').href = currentVendorHrefArray[0].concat('/', gender);
  }

  if(localStorage.getItem('redirect_param')) {
    AccountParameterHandler.reloadWithParam(localStorage.getItem('redirect_param'));
  }

})

if (!customElements.get('counter-collections')) {
  class CounterCollections extends HTMLElement {
    constructor() {
      super();
      this.min = parseInt(this.dataset.min, 10);
      this.max = parseInt(this.dataset.max, 10);
      this.counterDiv = this.querySelector('.round-number');
      this.today = new Date(this.dataset.today);
      this.counterDiv.innerHTML = this.dailyRandom();
    }
    hash(seed) {
      let hash = 0;
      for (let i = 0; i < seed.length; i++) {
        hash = (hash << 5) - hash + seed.charCodeAt(i);
        hash |= 0; // Converte in intero a 32 bit
      }
      return Math.abs(hash);
    }
    dailyRandom() {
      const startOfYear = new Date(this.today.getFullYear(), 0, 1);
      const dayOfYear = Math.floor((this.today - startOfYear) / (1000 * 60 * 60 * 24)) + 1;
      const seed = `${this.today.getFullYear()}-${dayOfYear}`;
      const hashedValue = this.hash(seed);
      const range = this.max - this.min + 7;
      const pseudoRandom = (hashedValue % range) + this.min;
      return pseudoRandom;
    }
  }
  customElements.define('counter-collections', CounterCollections);
}

if (!customElements.get('text-above')) {
  class TextAbove extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const parentSection = this.closest('section');
      if (!parentSection) return;

      const sameSectionElements = Array.from(
        document.querySelectorAll('text-above')
      ).filter(element => element.closest('section') === parentSection);

      if (sameSectionElements.length <= 1) return;

      // Funzione per calcolare altezza + margini dai data-attribute
      const calculateMaxHeightWithMargins = element => {
        if (!element) return 0;

        // Altezza visibile
        const visibleHeight = element.offsetHeight;

        // Margini presi dai data-attribute
        const marginTop = parseFloat(element.getAttribute('data-margin-top')) || 0;
        const marginBottom = parseFloat(element.getAttribute('data-margin-bottom')) || 0;

        // Altezza totale: visibile + margini
        return visibleHeight + marginTop + marginBottom;
      };

      // Calcola l'altezza massima includendo i margini
      const maxHeight = Math.max(
        ...sameSectionElements.map(element => calculateMaxHeightWithMargins(element))
      );

      // Imposta l'altezza massima ai singoli elementi
      sameSectionElements.forEach(element => {
        const marginTop = parseFloat(element.getAttribute('data-margin-top')) || 0;
        const marginBottom = parseFloat(element.getAttribute('data-margin-bottom')) || 0;

        // Imposta l'altezza come maxHeight meno i margini
        element.style.height = `${maxHeight - marginTop - marginBottom}px`;
      });
    }
  }

  customElements.define('text-above', TextAbove);
}

class CustomDialog extends HTMLElement {
  constructor() {
    
    super();
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
  }

  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    const dataTargetValue = this.getAttribute('data-target'); 
    this.buttons = document.querySelectorAll(`button[data-target="${dataTargetValue}"]`);
    this.closeButton = this.querySelectorAll(`button[data-dialog="close"]`);

    if (!this.dialog) 
      return
    

    this.buttons.forEach(button => {
      button.addEventListener('click', this.handleButtonClick);
    });

    this.closeButton.forEach(button => {
      button.addEventListener('click',() => {
        if (this.dialog.querySelector('.dialog')) {
          this.dialog.querySelector('.dialog')?.classList.add('fade-in');
        } else {
          this.dialog.classList.remove('fade-in');
        }
        this.dialog.close();
      });
    });

    this.dialog.addEventListener('click', this.handleDialogClose);

  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.handleButtonClick);
    }
    if (this.dialog) {
      this.dialog.removeEventListener('close', this.handleDialogClose);
    }
  }

  handleButtonClick() {
    if (!this.dialog) return

    const dialogToFadeIn = this.dialog.querySelector('.dialog') || this.dialog
    dialogToFadeIn.classList.add('fade-in');
    this.dialog.showModal();

  }

  handleDialogClose(event) {
    publish(PUB_SUB_EVENTS.popupClose)
    if (!this.dialog) return
    const rect = this.dialog.getBoundingClientRect();
    const isInDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    if (isInDialog) return
    setTimeout(() =>{
        this.dialog.close();
    }, 400);

    if (this.dialog.querySelector('.dialog')) {
      this.dialog.querySelector('.dialog')?.classList.add('fade-in');
    } else {
      this.dialog.classList.remove('fade-in');
    }
  }

}
customElements.define('custom-dialog', CustomDialog);
class CountryBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.checkCountry();
  }

  async checkCountry() {
    const isForced = AntonioliCookieFunctions.getCookieValue('forceLocalization') || sessionStorage.getItem('forceLocalization');
    if (isForced) return
    if (!this.dataset.userCountry) return

    const url = '/browsing_context_suggestions.json';
    const response = await fetch(url);
    const result = await response.json();

    const navigationCountry = result.detected_values.country
    if (navigationCountry.handle === this.dataset.userCountry) return

    this.setTimer();
    this.setListeners(navigationCountry);

    this.removeAttribute('hidden');

    this.querySelector('[data-country]').innerHTML = navigationCountry.name + ' (' + navigationCountry.handle + ')';
    this.querySelector('[data-stay-on]').innerHTML = navigationCountry.handle;
  }

  setListeners(navigationCountry) {
    this.querySelector('[data-localization-change]').addEventListener('click', () => {
      this.querySelector('[data-localization-select]').value = this.dataset.userCountry;
      AntonioliCookieFunctions.createCookie('forceLocalization', true);
      this.querySelector('form').submit();
    });

    this.querySelector('[data-localization-continue]').addEventListener('click', () => {
      this.querySelector('[data-localization-select]').value = navigationCountry.handle;
      AntonioliCookieFunctions.createCookie('forceLocalization', true);
      this.querySelector('form').submit();
    });

    this.querySelector('[data-localization-sidebar]').addEventListener('click', () => {
      document.querySelector('.sidebar-content .open-countries')?.click()
    });
  }

  setTimer() {
    const expireSecond = this.dataset.expire || 0;
    if (expireSecond == 0) return;

    setTimeout(() => {
      this.toggleAttribute('hidden', true);
      sessionStorage.setItem('forceLocalization', true);
    }, expireSecond * 1000);
  }
}

customElements.define('country-bar', CountryBar);

if (Antonioli.settings.template === 'collection' && !['woman', 'man'].includes(Antonioli.settings.templateSuffix)) {
  const key = 'bfcache-' + window.location.pathname;
  let ignoreScroll = false;

  document.addEventListener('click', (e) => {
    const link = e.target;
    if (!link) return;

    ignoreScroll = link.classList.contains('pagination__item');
  });

  window.addEventListener('pageshow', function () {
    const item = JSON.parse(localStorage.getItem(key));
    const currentScroll = parseInt(item.scroll || item, 10);
    const time = item.time || 0;

    if (currentScroll && Date.now() - time < 3000) 
      window.scrollTo(0, parseInt(currentScroll, 10));
    
    localStorage.removeItem(key);
  });

  window.addEventListener('pagehide', () => {
    if (!ignoreScroll) {
      const scrollData = {
        scroll: window.scrollY,
        time: Date.now()
      };
      localStorage.setItem(key, JSON.stringify(scrollData));
    }
  });
}